module.exports = __webpack_public_path__ + "static/about-two-small-cdfec0391be25194c7ab11ad9496c908.webp";